<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import { useRoute } from 'vue-router'

    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    import type { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { DependentEntityInfo } from '@common/types'

    // ---------------- props ----------------

    const props = defineProps<{
        readModel: FormDefDependenciesReadModel | null
    }>()

    // ---------------- router ----------------

    const route = useRoute()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- computed ----------------

    const requestPages = computed<DependentEntityInfo[]>(() =>
        rm.value?.RequestPages ?? []
    )

    // ---------------- url helpers ----------------

    function url_EditRequestPagePage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Pages_EditRequestPagePage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    function url_ReportViewPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Reports_ReportViewPage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            e.Id
        )
    }
</script>

<template>
    <div>
        <h4 v-if="!rm">
            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
        </h4>

        <div v-if="rm">
            <div class="card" v-if="requestPages.length > 0">
                <div class="card-header">
                    RequestPages ({{requestPages.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"
                        v-for="p in requestPages"
                        :key="p.Id">
                        <a class="text-primary"
                           target="_blank"
                           v-sanitizedHref="url_EditRequestPagePage(p)">
                            {{p.Name}}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Reports.length > 0">
                <div class="card-header">
                    Reports ({{rm.Reports.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"
                        v-for="r in rm.Reports"
                        :key="r.Id">
                        <a class="text-primary"
                           target="_blank"
                           v-sanitizedHref="url_ReportViewPage(r)">
                            {{r.Name}}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Notifications.length > 0">
                <div class="card-header">
                    Notifications ({{rm.Notifications.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"
                        v-for="n in rm.Notifications"
                        :key="n.Id">
                        <span>{{n.Name}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
